import { render, staticRenderFns } from "./MemberGatePasses.vue?vue&type=template&id=67ff9f20&scoped=true"
import script from "./MemberGatePasses.vue?vue&type=script&lang=js"
export * from "./MemberGatePasses.vue?vue&type=script&lang=js"
import style0 from "./MemberGatePasses.vue?vue&type=style&index=0&id=67ff9f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff9f20",
  null
  
)

export default component.exports